export function unifyTouchEvents(e) {
  return e.changedTouches ? e.changedTouches[0] : e;
}

export const isVideo = (item = {}) => 'videoType' in item;

export const getVideoUrl = ({ embedId, videoType }) => {
  switch (videoType) {
    case 'YouTube': {
      return `https://www.youtube.com/embed/${embedId}`;
    }
    case 'Vimeo': {
      return `https://player.vimeo.com/video/${embedId}`;
    }
    case 'iSiteTV': {
      return `https://isitetv.com/isitetv_cms/player.php?encoded=${embedId}`;
    }
    default:
      return null;
  }
};

export const stopVideo = (position) => {
  const item = document.querySelectorAll('.bop-gallery__item')[position];
  if (item) {
    /* ToDo: WEBSHOP-25450 - Replace with proper source API call */
    const video = item.querySelector('.bop-gallery__video');
    video.src += '';
  }
};

export const classIfItemIsChosen = (showItemIndex = 0, index = 0, className) => (
  index === showItemIndex ? `bop-gallery__${className}--chosen` : '');

export const shouldGoRight = (currentlyChosenItem, direction) => currentlyChosenItem > 0 && direction > 0;
export const shouldGoLeft = (currentlyChosenItem, numberOfItems, direction) =>
  currentlyChosenItem < numberOfItems - 1 && direction < 0;
